const facilities = [
  {
    name: "Grand Forks Main Post Office",
    address: "3300 S 34th St, Grand Forks, ND 58201",
    hours: "Mon–Fri 8:30am–5:00pm",
    phone: "(701) 746-1900",
    type: "Post Office",
    notes: "Primary passport acceptance facility for downtown Grand Forks. Walk-ins accepted.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Grand Forks East Post Office",
    address: "1300 S Columbia Rd, Grand Forks, ND 58201",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(701) 777-3427",
    type: "Post Office",
    notes: "Convenient near UND campus and east Grand Forks residents.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Grand Forks County Clerk",
    address: "124 S 4th St, Grand Forks, ND 58201",
    hours: "Mon–Fri 8:00am–4:30pm",
    phone: "(701) 780-8226",
    type: "County Clerk",
    notes: "Accepts passport applications. Bring photo ID.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "East Grand Forks Post Office",
    address: "102 3rd St NW, East Grand Forks, MN 56721",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(218) 773-4121",
    type: "Post Office",
    notes: "Serves Minnesota side of the Red River Valley border area.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Crookston Post Office",
    address: "118 N Broadway, Crookston, MN 56716",
    hours: "Mon–Fri 9:00am–4:30pm",
    phone: "(218) 281-2613",
    type: "Post Office",
    notes: "Convenient for southern Red River Valley residents, 25 miles south.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Larimore Post Office",
    address: "105 W Front St, Larimore, ND 58251",
    hours: "Mon–Fri 9:00am–4:00pm",
    phone: "(701) 343-2340",
    type: "Post Office",
    notes: "Serves western Grand Forks County — 30 miles west of Grand Forks.",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit Passport Applications in Grand Forks
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the passport acceptance facilities serving Grand Forks and the northern Red River Valley. Fast Passport Center will guide you to the right location.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${f.type === "Post Office" ? "ri-mail-line" : "ri-building-2-line"} text-[#1A365D]`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>
              <ul className="space-y-2 text-sm text-gray-500 flex-1">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.address}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.hours}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.phone}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </li>
                <li className="flex items-start gap-2 pt-2 border-t border-gray-100 text-gray-400 italic">
                  <i className="ri-information-line text-gray-300 flex-shrink-0 mt-0.5"></i>
                  {f.notes}
                </li>
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-7 text-center">
          <h3 className="font-bold text-white text-lg mb-2">Not Sure Which Facility to Use?</h3>
          <p className="text-white/60 text-sm mb-5">
            Fast Passport Center will tell you exactly which acceptance facility is best for your location and schedule — and precisely what to bring.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            Get Personalized Guidance <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}